import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Shravan from "@/pages/Shravan";
import PujaDetail from "@/pages/PujaDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomCursor from "@/components/CustomCursor";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/events">
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shravan" element={<Shravan />} />
        <Route path="/puja/:id" element={<PujaDetail />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
